import {
    AuditLogChangeType,
    AuditLogDiff,
    ResourceType,
} from "@common/types/auditLog";

export interface RuleVersion {
    versionId: string;
    logDate: Date;
    changeType: AuditLogChangeType;
    resourceType?: ResourceType;
    ruleGroupName: string;
    diffs: AuditLogDiff[];
    resource?: Record<string, unknown>;
    metadata?: Record<string, unknown> | null;
}

const RULE_DISPLAYABLE_FIELDS: Record<string, string> = {
    conditions: "Conditions",
    actions: "Actions",
    isDisabled: "Status",
    order: "Order",
    groupId: "Group",
    note: "Memo",
    source: "Source",
};

export const isConditionField = (field: string): boolean =>
    field.startsWith("condition:");

export const isActionField = (field: string): boolean =>
    field.startsWith("action:");

export const getRuleFieldLabel = (field: string): string | undefined => {
    if (isConditionField(field) || isActionField(field)) {
        return field;
    }
    return RULE_DISPLAYABLE_FIELDS[field];
};
